export const POSTER_MOBILE_TIMELINE_HEIGHT_RATIO = 0.5;
export const MOBILE_TIMELINE_MIN_HEIGHT = 110;
export const MOBILE_TIMELINE_MAX_HEIGHT = 800;
export const MOBILE_TIMELINE_DEFAULT_HEIGHT = 220;
/** The whiteboard keeps at least this much of the editor area; the timeline may not grow (or restore from a taller viewport) past it. */
export const MOBILE_TIMELINE_MIN_WHITEBOARD_HEIGHT = 200;
export interface PosterEditorMobileTimelineProps {}
